/* eslint-disable no-useless-escape */
import React from "react";
import "../../pages/NavbarHeader/navbarheader.css";
import Button from "../GenericComponents/Button";
import video from "../../img/video.mp4";
import { IHaveButton } from "./jumbotron.d"
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocation } from 'react-router-dom';
import { getImage } from "../GenericComponents/functions";
 
const delimiters = /[\/#:]/;


const Jumbotron: React.FC<IHaveButton> = ({ haveButton }: IHaveButton) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const infoOthers: any = t("others", { returnObjects: true });
    const infoMenus: any = t("menu", { returnObjects: true });
    let imgSrc = null;
    const path = location.pathname;
    let tmpPath = path.split(delimiters).filter(Boolean);

    if (path === "/") { tmpPath = ["Home"] }

    if (tmpPath.length > 0) {
        let menuItem = infoMenus.filter((x: any) => { return x.navigateTo.includes(tmpPath[0]) })[0] || [];
        if (menuItem.submenus === null || tmpPath.length === 1) { imgSrc = menuItem.src }
        else if (tmpPath.length > 2) { imgSrc = menuItem.src }
        else {
            if (tmpPath[0] !== "ApplyNow") {
                menuItem = menuItem.submenus.filter((x: any) => { return x.navigateTo.includes(tmpPath[1]) })[0] || [];
                imgSrc = menuItem.src;
            } else {
                imgSrc = menuItem.src
            }
        }
    }

    return (
        <div className="jumbotron">
            {imgSrc !== null && imgSrc.includes(".mp4") && (
                <video
                    className='w-[100vw] xl:h-full lg:h-full md:h-full object-fill'
                    muted
                    autoPlay
                    loop
                    playsInline
                >
                    <source src={video} type="video/mp4" />
                </video>
            )}
            {imgSrc !== null && !imgSrc.includes(".mp4") && (
                <img src={getImage(imgSrc)} alt={imgSrc} />
            )}

            <div className="button">
                {haveButton
                    ?
                    <Button
                        classProp={"blue-button"}
                        label={infoOthers.buttons[0].label}
                        size={"medium"}
                        onClick={() => navigate(`${infoOthers.buttons[0].navigateTo}`)}
                    />
                    :
                    <></>
                }

            </div>
        </div>
    );
};
export default Jumbotron;